module.exports = RA.config;


//////////////////
// WEBPACK FOOTER
// external "RA.config"
// module id = 5
// module chunks = 1